import { render } from "./layout-sidebar.vue?vue&type=template&id=7f05e972"
import script from "./layout-sidebar.vue?vue&type=script&lang=js"
export * from "./layout-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__